// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__pWINK","buttons":"Footer_buttons__201ck"};